module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Kartu Piutang History\n        ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.setMarkingCode()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingGetReceivable),
      expression: "loadingGetReceivable"
    }],
    attrs: {
      "size": "large"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.receivables.length > 0 || _vm.isSupervisor()) && _vm.markingIdSelected),
      expression: "(receivables.length > 0 || isSupervisor()) && markingIdSelected"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }), _vm._v(" "), _c('template', {
    slot: "extra"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCreateReceivable()),
      expression: "canCreateReceivable()"
    }],
    attrs: {
      "type": "success",
      "icon": "plus-round",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modal.createReceivable = true
      }
    }
  }, [_vm._v("\n                    Tambah Piutang\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topColor),
      expression: "topColor"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": _vm.topColor === 'GREEN' ? 'success' : _vm.topColor === 'YELLOW' ? 'warning' : _vm.topColor === 'RED' ? 'error' : 'info',
      "show-icon": ""
    }
  }, [_vm._v("\n                Term Of Payment\n              ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositRemaining > 0),
      expression: "depositRemaining > 0"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Deposit = " + _vm._s(_vm._f("currency")(_vm.depositRemaining)))]), _vm._v(" "), _c('Alert', {
    attrs: {
      "show-icon": ""
    }
  }, [_vm._v("Balance - Deposit = " + _vm._s(_vm._f("currency")((_vm.countBalance - _vm.depositRemaining))))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.depositMutasiRemaining > 0),
      expression: "depositMutasiRemaining > 0"
    }]
  }, [_c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("Deposit Mutasi = " + _vm._s(_vm._f("currency")(_vm.depositMutasiRemaining)))])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "columns": _vm.tableColumns,
      "data": _vm.receivables,
      "no-data-text": ""
    }
  })], 2)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        return _vm.clearCreateReceivable()
      }
    },
    model: {
      value: (_vm.modal.createReceivable),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createReceivable", $$v)
      },
      expression: "modal.createReceivable"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Piutang")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Transaksi"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.createReceivable.transactionDate),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "transactionDate", $$v)
      },
      expression: "createReceivable.transactionDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" \n                    ")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: (_vm.createReceivable.description),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "description", $$v)
      },
      expression: "createReceivable.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": "Jumlah"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.createReceivable.amount),
      callback: function($$v) {
        _vm.$set(_vm.createReceivable, "amount", $$v)
      },
      expression: "createReceivable.amount"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Upload File",
      "prop": "file"
    }
  }, [_c('br'), _vm._v(" "), _c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgress),
      expression: "isProgress"
    }],
    attrs: {
      "percent": _vm.pValue,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateReceivable
    },
    on: {
      "click": _vm.postCreateReceivable
    }
  }, [(!_vm.loadingCreateReceivable) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.modal.createPayment),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createPayment", $$v)
      },
      expression: "modal.createPayment"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Payment set")])], 1), _vm._v(" "), _c('Form', {
    attrs: {
      "label-width": 120
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tgl Pembayaran"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.checkButtonSave
    },
    model: {
      value: (_vm.createPaymentPending.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "paymentDate", $$v)
      },
      expression: "createPaymentPending.paymentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Marking"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "Marking"
    },
    model: {
      value: (_vm.createPaymentPending.selectedMarkingLabel),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "selectedMarkingLabel", $$v)
      },
      expression: "createPaymentPending.selectedMarkingLabel"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "250px"
    },
    on: {
      "on-change": _vm.checkButtonSave
    },
    model: {
      value: (_vm.createPaymentPending.description),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "description", $$v)
      },
      expression: "createPaymentPending.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Deposito Mutasi"
    }
  }, [_c('Alert', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.createPaymentPending.mutasiRemainingPayment)) + "\n                ")]), _vm._v(" "), (_vm.createPaymentPending.totalUseDepositAmount > 0 && _vm.createPaymentPending.totalUseDepositAmount > _vm.createPaymentPending.mutasiRemainingPayment) ? _c('font', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                    Terpakai\n                    " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.totalUseDepositAmount)) + " - LEBIH")]) : _vm._e(), _vm._v(" "), (_vm.createPaymentPending.totalUseDepositAmount > 0 && _vm.createPaymentPending.totalUseDepositAmount <= _vm.createPaymentPending.depositRemainingPayment) ? _c('font', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n                    Terpakai: " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.totalUseDepositAmount)) + ", Sisa: " + _vm._s(_vm._f("currency")((_vm.createPaymentPending.depositRemainingPayment -
    _vm.createPaymentPending.totalUseDepositAmount))) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Uang Diterima"
    }
  }, [_c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.createPaymentPending.amountReceived),
      callback: function($$v) {
        _vm.$set(_vm.createPaymentPending, "amountReceived", $$v)
      },
      expression: "createPaymentPending.amountReceived"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('font', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.createPaymentPending.amountResidue != 0),
      expression: "createPaymentPending.amountResidue != 0"
    }],
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("\n                    Selisih   " + _vm._s(_vm._f("currency")(_vm.createPaymentPending.amountResidue)) + "\n                ")])], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.invoiceDues.length > 0),
      expression: "this.invoiceDues.length > 0"
    }]
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                Daftar Invoice\n            ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg ivu-row-flex-space-between",
    attrs: {
      "type": "flex"
    }
  }, [
    [_c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Tgl Bongkar\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_vm._v("\n                    Keterangan\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Total\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    }), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_vm._v("\n                    Sisa\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    }), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [_vm._v("\n                    Alokasi Pembayaran\n                    ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "1"
      }
    })]
  ], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.invoiceDues), function(invoiceDue) {
    return _c('div', [_c('cInvoicePaymentMutasi', {
      attrs: {
        "invoiceDue": invoiceDue,
        "depositRemaining": _vm.createPaymentPending.depositRemainingPayment,
        "paymentPendingId": _vm.createPaymentPending.paymentPendingId,
        "paymentPendingAmount": _vm.createPaymentPending.paymentPendingAmount
      },
      on: {
        "setAllocateAmount": _vm.setAllocateAmount
      }
    }), _vm._v(" "), _c('br')], 1)
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isButtonSave),
      expression: "isButtonSave"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingCreateReceivable
    },
    on: {
      "click": _vm.postPayment
    }
  }, [(!_vm.loadingCreateReceivable) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707e3198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/ReceivableList.vue
// module id = 1827
// module chunks = 1